<template>
  <div>
    <PageAllow controller="Examines" action="view" />
    <Breadcrumbs :items="items" />
    <v-sheet class="transparent-background-color pa-4">
      <v-expansion-panels v-model="panels" multiple accordion>
        <v-expansion-panel>
          <v-expansion-panel-header>
            <v-card-title class="ms-n4 py-0">
              {{ $t("CRUD.info", [$t("Examine.ObjectName")]) }}
              <v-chip
                small
                label
                class="ms-4 mt-1"
                :color="examine.is_examined | examineStatusColor"
                :text-color="examine.is_examined | examineStatusTextColor"
                >{{ examine.is_examined | examineStatusText }}
              </v-chip>
              <v-spacer />
              <ExamineActions
                :examine="examine"
                :showExamine="
                  isView && examine.actions ? examine.actions.examine : false
                "
                :showAbnormal="
                  isView && examine.actions ? examine.actions.abnormal : false
                "
                :showAbnormalDetail="
                  isView && examine.actions
                    ? examine.actions.abnormal_detail
                    : false
                "
                detail-mode
                @edit="mode = 'edit'"
              />
              <v-sheet class="pt-1 transparent-background-color d-inline-block">
                <v-btn
                  v-if="savable"
                  small
                  dark
                  outlined
                  color="secondary"
                  class="px-2 me-2 mb-1 elevation-1"
                  @click.stop="mode = 'view'"
                >
                  <v-icon x-small class="pe-1">fa-times</v-icon>
                  {{ $t("CRUD.backForModify") }}
                </v-btn>
                <v-btn
                  v-if="
                    savable &&
                    $permission.permissionAllow('Examines', 'examine')
                  "
                  small
                  dark
                  color="primary"
                  class="px-2 me-2 mb-1"
                  @click.stop="doSubmit()"
                >
                  <v-icon x-small class="pe-1">fa-save</v-icon>
                  {{ $t("Examine.actions.examine_abnormal_edit") }}
                </v-btn>
              </v-sheet>
            </v-card-title>
          </v-expansion-panel-header>

          <v-expansion-panel-content>
            <v-divider />
            <v-row no-gutters class="mt-4 table-style">
              <v-col cols="12" md="4">
                <v-card class="pa-2 text-no-wrap" outlined tile>
                  <span class="secondary--text">
                    {{ $t("Examine.DetailFields.examine_code")
                    }}{{ $t("Global.colon") }}
                  </span>
                  {{ examine.examine_code }}
                </v-card>
              </v-col>
              <v-col cols="12" md="4">
                <v-card class="pa-2 text-no-wrap" outlined tile>
                  <span class="secondary--text">
                    {{ $t("Examine.DetailFields.created_time")
                    }}{{ $t("Global.colon") }}
                  </span>
                  {{ examine.created | formatTime }}
                </v-card>
              </v-col>
              <v-col v-if="isView" cols="12" md="4">
                <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                  <span class="secondary--text">
                    {{ $t("Examine.DetailFields.examine_time")
                    }}{{ $t("Global.colon") }}
                  </span>
                  <span> {{ examine.examine_time | formatTime }}</span>
                </v-card>
              </v-col>
              <v-col cols="12" md="4">
                <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                  <span class="secondary--text">
                    {{ $t("Examine.DetailFields.examiner")
                    }}{{ $t("Global.colon") }}
                  </span>
                  <span v-if="examine.examine_flg == 1">
                    {{ examine.shop_user_name }}
                  </span>
                  <span v-else>
                    {{ examine.examine_flg | examineFlgsText }}</span
                  >
                </v-card>
              </v-col>
              <v-col v-if="isView" cols="12" md="8">
                <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                  <span class="secondary--text">
                    {{ $t("Examine.DetailFields.distribution_info")
                    }}{{ $t("Global.colon") }}
                  </span>
                  <span>
                    {{
                      (examine && examine.stock ? examine.stock.name : "") +
                      " - " +
                      examine.distribution_user_name
                    }}
                  </span>
                </v-card>
              </v-col>
              <v-col v-if="savable" cols="12" md="4">
                <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                  <span class="secondary--text">
                    {{ $t("Examine.DetailFields.distribution_info")
                    }}{{ $t("Global.colon") }}
                  </span>
                  <span>
                    {{
                      (examine && examine.stock ? examine.stock.name : "") +
                      " - " +
                      examine.distribution_user_name
                    }}
                  </span>
                </v-card>
              </v-col>
              <v-col cols="12" md="12">
                <v-card class="pa-2 text-no-wrap" outlined tile>
                  <span class="secondary--text">
                    {{
                      $t("Examine.DetailFields.shop_name", [
                        $consts.shopName(),
                      ])
                    }}{{ $t("Global.colon") }}
                  </span>
                  {{ examine && examine.shop ? examine.shop.shop_name : "" }}
                </v-card>
              </v-col>
              <v-col cols="12" md="4">
                <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                  <span class="secondary--text">
                    {{ $t("Examine.DetailFields.receiver")
                    }}{{ $t("Global.colon") }}
                  </span>
                  <span>
                    {{
                      receiverInfo
                        ? receiverInfo.user_name
                        : examine.shop_user_name
                    }}
                  </span>
                </v-card>
              </v-col>
              <v-col cols="12" md="8">
                <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                  <span class="secondary--text">
                    {{ $t("Examine.DetailFields.contact_number")
                    }}{{ $t("Global.colon") }}
                  </span>
                  <span>{{
                    receiverInfo
                      ? receiverInfo.tel
                      : examine && examine.shop && examine.shop.shop_user
                      ? examine.shop.shop_user.tel
                      : ""
                  }}</span>
                </v-card>
              </v-col>
              <v-col cols="12" md="12">
                <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                  <span class="secondary--text">
                    {{
                      $t("Examine.DetailFields.shop_address", [
                        $consts.shopName(),
                      ])
                    }}{{ $t("Global.colon") }}
                  </span>
                  <span v-if="receiverInfo">{{ receiverInfo.address }}</span>
                  <AddressText
                    v-else
                    :masterItem="examine ? examine.shop : null"
                    :detailAddress="
                      examine && examine.shop ? examine.shop.address : ''
                    "
                  />
                </v-card>
              </v-col>
              <v-col cols="12" sm="12" md="12">
                <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                  <span class="secondary--text"
                    >{{ $t("Examine.DetailFields.memo")
                    }}{{ $t("Global.colon") }}
                  </span>
                  <span>
                    {{ examine.account_memo }}
                  </span>
                </v-card>
              </v-col>
              <v-col cols="12" sm="12" md="12">
                <v-card
                  class="pa-2 d-flex overflow-auto align-end"
                  outlined
                  tile
                >
                  <!-- 附件 -->
                  <span class="secondary--text text-no-wrap">
                    {{ $t("Order.Fields.attachments") }}{{ $t("Global.colon") }}
                    <v-icon
                      v-if="isView && !editExamineImg && examine && examine.id"
                      small
                      color="primary"
                      class="ml-5"
                      @click.stop="editExamineImg = true"
                      >fa-pencil-alt
                    </v-icon>
                    <v-icon
                      v-if="editExamineImg"
                      small
                      color="primary"
                      class="ml-5"
                      @click.stop="
                        editExamineImg = false;
                        updateExamineImg();
                      "
                    >
                      fa-check
                    </v-icon>
                    <v-icon
                      v-if="editExamineImg"
                      small
                      color="primary"
                      class="ml-2"
                      @click.stop="
                        editExamineImg = false;
                        resetExamineImg();
                      "
                    >
                      fa-times
                    </v-icon>
                  </span>
                  <!-- 上传附件1 -->
                  <span class="ml-4">
                    <v-card v-if="img_one" width="140" height="100">
                      <v-img
                        :src="img_one"
                        @click.stop="$showFullscreenImages([img_one])"
                        v-if="
                          img_one.startsWith('data:image/') ||
                          ['jpg', 'jpeg', 'gif', 'png'].includes(
                            img_one
                              .substring(img_one.lastIndexOf('.') + 1)
                              .toLowerCase()
                          )
                        "
                        width="140"
                        height="100"
                      >
                        <v-tooltip
                          right
                          v-if="(savable || editExamineImg) && img_one"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon
                              v-bind="attrs"
                              v-on="on"
                              color="secondary"
                              class="pa-2 float-right"
                              @click.stop="
                                !img_one.startsWith('data:image/') &&
                                img_one == img_url_one
                                  ? (img_url_one = img_one = null)
                                  : (img_one = null)
                              "
                            >
                              fa-times
                            </v-icon>
                          </template>
                          <span> {{ $t("Material.delImg") }}</span>
                        </v-tooltip>
                      </v-img>
                      <div v-else max-width="140" style="position: relative">
                        <span
                          style="
                            position: absolute;
                            top: 0;
                            right: 0;
                            z-index: 99;
                          "
                          @click.stop="
                            !img_one.startsWith('data:image/') &&
                            img_one == img_url_one
                              ? (img_url_one = img_one = null)
                              : (img_one = null)
                          "
                          v-if="(savable || editExamineImg) && img_one"
                        >
                          <v-icon color="secondary" class="pa-2 float-right">
                            fa-times
                          </v-icon>
                        </span>
                        <video width="140" height="100" controls>
                          <source :src="img_one" type="video/mp4" />
                        </video>
                      </div>
                    </v-card>
                    <v-file-input
                      ref="img_file_one"
                      v-if="savable || editExamineImg"
                      show-size
                      counter
                      small-chips
                      suffix
                      prepend-icon="fa-camera"
                      accept="image/png, image/jpeg"
                      persistent-hint
                      :placeholder="$t('Material.imgsPlaceholder')"
                      :hint="$t('Material.imgsHint')"
                      :rules="imgRules"
                      v-model="img_file_one"
                    >
                    </v-file-input>
                  </span>
                  <div v-if="!showImgTwoFlg && (savable || editExamineImg)">
                    <v-btn
                      small
                      color="primary"
                      class="ms-1"
                      @click.stop="showImgTwoFlg = true"
                    >
                      <v-icon x-small class="pe-1">fa-plus</v-icon>
                    </v-btn>
                  </div>
                  <!-- 上传附件2 -->
                  <span class="ml-4" v-if="showImgTwoFlg || isView">
                    <v-card v-if="img_two" width="140" height="100">
                      <v-img
                        :src="img_two"
                        @click.stop="$showFullscreenImages([img_two])"
                        v-if="
                          img_two.startsWith('data:image/') ||
                          ['jpg', 'jpeg', 'gif', 'png'].includes(
                            img_two
                              .substring(img_two.lastIndexOf('.') + 1)
                              .toLowerCase()
                          )
                        "
                        width="140"
                        height="100"
                      >
                        <v-tooltip
                          right
                          v-if="(savable || editExamineImg) && img_two"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon
                              v-bind="attrs"
                              v-on="on"
                              color="secondary"
                              class="pa-2 float-right"
                              @click.stop="
                                !img_two.startsWith('data:image/') &&
                                img_two == img_url_two
                                  ? (img_url_two = img_two = null)
                                  : (img_two = null)
                              "
                            >
                              fa-times
                            </v-icon>
                          </template>
                          <span> {{ $t("Material.delImg") }}</span>
                        </v-tooltip>
                      </v-img>
                      <div
                        v-else
                        width="140"
                        height="100"
                        style="position: relative"
                      >
                        <span
                          style="
                            position: absolute;
                            top: 0;
                            right: 0;
                            z-index: 99;
                          "
                          @click.stop="
                            !img_two.startsWith('data:image/') &&
                            img_two == img_url_two
                              ? (img_url_two = img_two = null)
                              : (img_two = null)
                          "
                          v-if="(savable || editExamineImg) && img_two"
                        >
                          <v-icon color="secondary" class="pa-2 float-right">
                            fa-times
                          </v-icon>
                        </span>
                        <video width="140" height="100" controls>
                          <source :src="img_two" type="video/mp4" />
                        </video>
                      </div>
                    </v-card>
                    <v-file-input
                      ref="img_file_two"
                      v-if="(savable || editExamineImg) && showImgTwoFlg"
                      show-size
                      counter
                      small-chips
                      suffix
                      prepend-icon="fa-camera"
                      accept="image/png, image/jpeg"
                      persistent-hint
                      :placeholder="$t('Material.imgsPlaceholder')"
                      :hint="$t('Material.imgsHint')"
                      :rules="imgRules"
                      v-model="img_file_two"
                    >
                    </v-file-input>
                  </span>
                  <div
                    v-if="
                      showImgTwoFlg &&
                      !showImgThreeFlg &&
                      (savable || editExamineImg)
                    "
                  >
                    <v-btn
                      small
                      color="primary"
                      class="ms-1"
                      @click.stop="showImgThreeFlg = true"
                    >
                      <v-icon x-small class="pe-1">fa-plus</v-icon>
                    </v-btn>
                  </div>
                  <!-- 上传附件3 -->
                  <span class="ml-4" v-if="showImgThreeFlg || isView">
                    <v-card v-if="img_three" width="140" height="100">
                      <v-img
                        :src="img_three"
                        @click.stop="$showFullscreenImages([img_three])"
                        v-if="
                          img_three.startsWith('data:image/') ||
                          ['jpg', 'jpeg', 'gif', 'png'].includes(
                            img_three
                              .substring(img_three.lastIndexOf('.') + 1)
                              .toLowerCase()
                          )
                        "
                        width="140"
                        height="100"
                      >
                        <v-tooltip
                          right
                          v-if="(savable || editExamineImg) && img_three"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon
                              v-bind="attrs"
                              v-on="on"
                              color="secondary"
                              class="pa-2 float-right"
                              @click.stop="
                                !img_three.startsWith('data:image/') &&
                                img_three == img_url_three
                                  ? (img_url_three = img_three = null)
                                  : (img_three = null)
                              "
                            >
                              fa-times
                            </v-icon>
                          </template>
                          <span> {{ $t("Material.delImg") }}</span>
                        </v-tooltip>
                      </v-img>
                      <div
                        v-else
                        width="140"
                        height="100"
                        style="position: relative"
                      >
                        <span
                          style="
                            position: absolute;
                            top: 0;
                            right: 0;
                            z-index: 99;
                          "
                          @click.stop="
                            !img_three.startsWith('data:image/') &&
                            img_three == img_url_three
                              ? (img_url_three = img_three = null)
                              : (img_three = null)
                          "
                          v-if="(savable || editExamineImg) && img_three"
                        >
                          <v-icon color="secondary" class="pa-2 float-right">
                            fa-times
                          </v-icon>
                        </span>
                        <video width="140" height="100" controls>
                          <source :src="img_three" type="video/mp4" />
                        </video>
                      </div>
                    </v-card>
                    <v-file-input
                      ref="img_file_three"
                      v-if="(savable || editExamineImg) && showImgThreeFlg"
                      show-size
                      counter
                      small-chips
                      suffix
                      prepend-icon="fa-camera"
                      accept="image/png, image/jpeg"
                      persistent-hint
                      :placeholder="$t('Material.imgsPlaceholder')"
                      :hint="$t('Material.imgsHint')"
                      :rules="imgRules"
                      v-model="img_file_three"
                    >
                    </v-file-input>
                  </span>
                </v-card>
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel>
          <v-expansion-panel-header class="py-0">
            <v-tabs v-model="tab" background-color="transparent">
              <v-tab
                @click.stop="
                  tab = 0;
                  panels.find((p) => p == 1) ? null : panels.push(1);
                "
              >
                {{ $t("Distribution.actions.activities") }}
              </v-tab>
              <v-tab
                @click.stop="
                  tab = 1;
                  panels.find((p) => p == 1) ? null : panels.push(1);
                "
              >
                {{ $t("Order.actions.relations") }}
              </v-tab>
            </v-tabs>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-tabs-items v-model="tab">
              <v-tab-item>
                <v-card flat>
                  <v-data-table
                    :headers="activitiesHeaders"
                    :items="examine_activities"
                    class="elevation-0"
                    disable-pagination
                    hide-default-footer
                  >
                    <template v-slot:item.created="{ item }">
                      <span class="text-no-wrap">
                        {{ item.created | formatTime }}
                      </span>
                    </template>
                  </v-data-table>
                </v-card>
              </v-tab-item>
              <v-tab-item>
                <v-card flat>
                  <v-data-table
                    :headers="relationsHeaders"
                    :items="examine_relations"
                    class="elevation-0"
                    disable-pagination
                    hide-default-footer
                  >
                    <template v-slot:header.actions="{ header }">
                      {{ header.text }}
                      <v-icon x-small>fa-sliders-h</v-icon>
                    </template>

                    <template v-slot:item.identify_name="{ item }">
                      <span v-if="!item.index" class="text-no-wrap">
                        {{ item.identify_name }}
                      </span>
                    </template>
                    <template v-slot:item.identify_code="{ item }">
                      <span v-if="item.identify == 'stock-orders-out'">
                        {{ item.identify_code }}
                        <a
                          v-if="item.purchase_code"
                          class="text-no-wrap"
                          :href="'/#/purchases/detail/' + item.purchase_id"
                        >
                          {{ item.purchase_code }}
                        </a>
                      </span>
                      <span class="text-no-wrap" v-else>
                        {{ item.identify_code }}
                      </span>
                      <br />
                      <span v-if="item.stock">
                        {{ item.stock.name }}
                      </span>
                    </template>
                    <template v-slot:item.status="{ item }">
                      <div v-if="item.status >= 0" class="text-no-wrap">
                        <v-chip
                          v-if="
                            item.identify == 'orders' &&
                            (item.cancel_flg || item.error_flg)
                          "
                          small
                          label
                          outlined
                          color="danger"
                          class="me-1"
                        >
                          {{
                            item.cancel_flg
                              ? $t("CRUD.cancelled")
                              : $t("Order.redeliverError")
                          }}
                        </v-chip>
                        <v-chip
                          v-if="item.identify == 'orders'"
                          small
                          label
                          :color="item.status | orderStatusColor"
                          :text-color="item.status | orderStatusTextColor"
                          >{{ item.status | orderStatusText }}
                        </v-chip>
                        <v-chip
                          v-if="item.identify == 'stock-orders-out'"
                          small
                          label
                          :color="item.status | stockOrderOUTStatusColor"
                          :text-color="
                            item.status | stockOrderOUTStatusTextColor
                          "
                          >{{ item.status | stockOrderOUTStatusText }}
                        </v-chip>
                        <v-chip
                          v-if="item.identify == 'distributions'"
                          small
                          label
                          :color="item.status | distributionStatusColor"
                          :text-color="
                            item.status | distributionStatusTextColor
                          "
                          >{{ item.status | distributionStatusText }}
                        </v-chip>
                        <v-chip
                          v-if="item.identify == 'examines'"
                          small
                          label
                          :color="item.status | examineStatusColor"
                          :text-color="item.status | examineStatusTextColor"
                          >{{ item.status | examineStatusText }}
                        </v-chip>
                        <v-chip
                          v-if="item.identify == 'receipts'"
                          small
                          label
                          :color="item.pay_flg | billPayFlgsColor"
                          :text-color="item.pay_flg | billPayFlgsTextColor"
                          >{{ item.pay_flg | billPayFlgsText }}
                        </v-chip>
                        <v-chip
                          v-if="item.identify == 'receipts'"
                          small
                          label
                          class="ms-1"
                          :color="item.status | billStatusColor"
                          :text-color="item.status | billStatusTextColor"
                          >{{ item.status | billStatusText }}
                        </v-chip>
                      </div>
                    </template>
                    <template v-slot:item.created="{ item }">
                      <span class="text-no-wrap">
                        {{ item.created | formatTime }}
                      </span>
                    </template>
                    <template v-slot:item.actions="{ item }">
                      <v-btn
                        v-if="
                          item.identify != 'examines' &&
                          $permission.permissionAllow(item.controller, 'view')
                        "
                        small
                        outlined
                        color="info"
                        class="px-2 me-2"
                        :href="'/#/' + item.identify + '/' + item.id"
                      >
                        <v-icon x-small class="pe-1">fa-align-left</v-icon>
                        {{ $t("Opt.details") }}
                      </v-btn>
                    </template>
                  </v-data-table>
                </v-card>
              </v-tab-item>
            </v-tabs-items>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
      <ValidationObserver ref="observer">
        <v-data-table
          :headers="detailsHeaders"
          :items="examineDetails"
          :search="filter"
          disable-pagination
          hide-default-footer
          :no-data-text="$t('Order.DetailNoData')"
          class="elevation-2 px-4 mt-4"
        >
          <template v-slot:top>
            <v-toolbar flat class="transparent-background-color">
              <v-toolbar-title class="ms-n2">
                {{ $t("CRUD.details", [$t("Examine.ObjectName")]) }}
              </v-toolbar-title>
              <v-spacer />
              <span>
                <span class="font-weight-bold me-2"
                  >{{ $t("Examine.DetailFields.sum_price")
                  }}{{ $t("Global.colon") }}</span
                >
                {{ $t("Global.money") }}
                {{ examine.total_subtotal_price | formatMoneyFloor }}
              </span>
            </v-toolbar>
            <v-divider />
            <v-toolbar
              flat
              class="transparent-background-color"
              align-self="center"
            >
              <span class="caption secondary--text pt-2">
                {{
                  $t(
                    "$vuetify.dataFooter.pageText",
                    examineDetails
                      ? [1, examineDetails.length, examineDetails.length]
                      : [0, 0, 0]
                  )
                }}
              </span>
              <v-spacer />
              <v-row no-gutters class="me-n3">
                <v-spacer />
                <v-col cols="12" sm="9" md="8">
                  <v-text-field
                    v-model="filter"
                    clearable
                    hide-details
                    :label="$t('Search.filter')"
                  />
                </v-col>
              </v-row>
            </v-toolbar>
          </template>
          <template v-slot:item.material_name="{ item }">
            <span v-if="item.abnormal_flg" class="danger--text">
              {{ item.material_name }}
            </span>
            <span v-else>
              {{ item.material_name }}
            </span>
            <br />
            <span
              v-if="item.material.standard_name"
              class="caption secondary--text"
            >
              {{ $t("Material.Fields.standard") }}{{ $t("Global.colon") }}
              <span
                v-if="
                  item.material &&
                  item.material.standard_name &&
                  item.material.standard_name.length > 12
                "
                :title="item.material.standard_name"
                style="cursor: pointer"
              >
                {{ item.material.standard_name.slice(0, 12) + "......" }}
              </span>
              <span v-else>
                {{ item.material.standard_name }}
              </span>
            </span>
          </template>
          <template v-slot:item.order_num="{ item }">
            {{ item.order_num | formatTwoDot }}
          </template>
          <template v-slot:item.distribution_num="{ item }">
            {{ item.distribution_num | formatTwoDot }}
          </template>
          <template v-slot:item.examine_num="{ item }">
            <ValidationProvider
              v-if="savable"
              v-slot="{ errors }"
              :rules="
                isEditNumEnable
                  ? {
                      sub_num: {
                        sub_num: item.distribution_num,
                      },
                    }
                  : null
              "
            >
              <NumberInput
                v-model="item.examine_num"
                dense
                :disabled="isSubDisabled"
                :error-messages="errors"
              />
            </ValidationProvider>
            <span v-else-if="item.abnormal_flg" class="danger--text">
              {{ item.examine_num | formatTwoDot }}
            </span>
            <span v-else>
              {{ item.examine_num | formatTwoDot }}
            </span>
          </template>
          <template v-slot:item.stock_examine_num="{ item }">
            <!-- 库存单位数量 -->
            <span v-if="examine.is_examined == 0 && !savable">
              {{
                (item.distribution_num *
                  (item.standard_detail.rate / item.stock_unit_rate))
                  | formatTwoDot
              }}{{ item.stock_unit }}
            </span>
            <span v-else>
              {{
                (item.examine_num *
                  (item.standard_detail.rate / item.stock_unit_rate))
                  | formatTwoDot
              }}{{ item.stock_unit }}
            </span>
          </template>
          <template v-slot:item.unit="{ item }">
            {{ item.unit }}
            <span
              v-if="item.material && item.standard_detail.rate > 1"
              class="caption secondary--text"
            >
              (1{{ item.unit }}={{ item.standard_detail.rate
              }}{{ item.material.standard.default_standard_detail.unit }})
            </span>
            <span
              v-if="item.standard_detail && item.standard_detail.barcode"
              class="caption secondary--text"
            >
              <br />
              {{ item.standard_detail ? item.standard_detail.barcode : "" }}
            </span>
          </template>
          <template v-slot:item.price="{ item }">
            {{ $t("Global.money") }}{{ item.price | formatMoney }}
          </template>
          <template v-slot:item.subtotal_price="{ item }">
            {{ $t("Global.money") }}{{ item.subtotal_price | formatMoneyFloor }}
          </template>
          <template v-slot:body.prepend>
            <tr no-gutters class="d-none d-sm-table-row">
              <td class="secondary--text" colspan="3">
                {{ $t("Examine.DetailFields.count_num") }}
              </td>
              <td class="align-end text-center">
                {{ examine.total_order_num | formatTwoDot }}
              </td>
              <td class="align-end text-center">
                {{ examine.total_distribution_num | formatTwoDot }}
              </td>
              <td class="align-end text-center">
                {{ examine.total_examine_num | formatTwoDot }}
              </td>
              <td colspan="3"></td>
              <td class="align-end text-center">
                {{ $t("Global.money")
                }}{{ examine.total_subtotal_price | formatMoney }}
              </td>
            </tr>
            <tr no-gutters class="d-table-row d-sm-none">
              <td class="v-data-table__mobile-row">
                <div class="v-data-table__mobile-row__header">
                  {{ $t("Examine.DetailFields.total_order_num") }}
                </div>
                <div class="v-data-table__mobile-row__cell">
                  {{ examine.total_order_num | formatTwoDot }}
                </div>
              </td>
              <td class="v-data-table__mobile-row">
                <div class="v-data-table__mobile-row__header">
                  {{ $t("Examine.DetailFields.total_distribution_num") }}
                </div>
                <div class="v-data-table__mobile-row__cell">
                  {{ examine.total_distribution_num | formatTwoDot }}
                </div>
              </td>
              <td class="v-data-table__mobile-row">
                <div class="v-data-table__mobile-row__header">
                  {{ $t("Examine.DetailFields.total_examine_num") }}
                </div>
                <div class="v-data-table__mobile-row__cell">
                  {{ examine.total_examine_num | formatTwoDot }}
                </div>
              </td>
              <td class="v-data-table__mobile-row">
                <div class="v-data-table__mobile-row__header">
                  {{ $t("Examine.DetailFields.total_subtotal_price") }}
                </div>
                <div class="v-data-table__mobile-row__cell">
                  {{ $t("Global.money")
                  }}{{ examine.total_subtotal_price | formatMoney }}
                </div>
              </td>
            </tr>
          </template>
        </v-data-table>
      </ValidationObserver>
    </v-sheet>
  </div>
</template>
<script>
import { mapState } from "vuex";
import i18n from "@/i18n";
import PageAllow from "@/components/PageAllow";
import Breadcrumbs from "@/components/Breadcrumbs";
import AddressText from "@/components/plugins/AddressText";
import Examines from "@/api/examines";
import ExamineActions from "./plugins/Actions";
import NumberInput from "@/components/plugins/NumberInput";
import Files from "@/api/files";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import Orders from "@/api/orders";

export default {
  components: {
    PageAllow,
    Breadcrumbs,
    AddressText,
    ExamineActions,
    NumberInput,
    ValidationObserver,
    ValidationProvider,
  },
  computed: {
    isView() {
      return !this.mode || this.mode == "view";
    },

    savable() {
      return this.mode == "edit";
    },

    items() {
      var items = [
        {
          text: i18n.t("Nav.home"),
          disabled: false,
          href: "/home",
        },
        {
          text: i18n.t("Nav.orderManagement"),
          disabled: false,
          href: "/orders",
        },
        {
          text: i18n.t("Nav.examines"),
          disabled: false,
          href: "/examines",
        },
        {
          text: i18n.t("Nav.examineDetail"),
          disabled: true,
        },
      ];

      return items;
    },

    detailsHeaders() {
      var headers = [
        {
          text: i18n.t("Examine.DetailFields.material_category"),
          align: "start",
          value: "category_name",
        },
        {
          text: i18n.t("Examine.DetailFields.material_code"),
          align: "start",
          value: "material_code",
        },
        {
          text: i18n.t("Examine.DetailFields.material_name"),
          align: "start",
          value: "material_name",
        },
        {
          text: i18n.t("Examine.DetailFields.apply_num"),
          align: "center",
          value: "order_num",
        },
        {
          text: i18n.t("Examine.DetailFields.distribute_num"),
          align: "center",
          value: "distribution_num",
        },
        {
          text: i18n.t("Examine.DetailFields.examine_num"),
          align: "center",
          value: "examine_num",
        },
        {
          text: i18n.t("Examine.DetailFields.unit"),
          align: "end",
          value: "unit",
        },
        {
          text: i18n.t("Examine.DetailFields.stock_examine_num"),
          align: "end",
          value: "stock_examine_num",
        },
        {
          text: i18n.t("Examine.DetailFields.price"),
          align: "end",
          value: "price",
        },
        {
          text: i18n.t("Examine.DetailFields.sum"),
          align: "end",
          value: "subtotal_price",
        },
      ];

      return headers;
    },

    activitiesHeaders: () => [
      {
        text: i18n.t("Examine.ActivityFields.created_time"),
        align: "start",
        sortable: false,
        value: "created",
      },
      {
        text: i18n.t("Examine.ActivityFields.content"),
        align: "start",
        sortable: false,
        value: "content",
      },
      {
        text: i18n.t("Examine.ActivityFields.operater"),
        align: "start",
        sortable: false,
        value: "operater_name",
      },
    ],
    relationsHeaders: () => [
      {
        text: i18n.t("Order.RelationFields.identify_name"),
        align: "center",
        sortable: false,
        value: "identify_name",
      },
      {
        text: i18n.t("Order.RelationFields.identify_code"),
        align: "center",
        sortable: false,
        value: "identify_code",
      },
      {
        text: i18n.t("Order.RelationFields.status"),
        align: "center",
        sortable: false,
        value: "status",
      },
      {
        text: i18n.t("Order.RelationFields.creater"),
        align: "start",
        sortable: false,
        value: "creater_name",
      },
      {
        text: i18n.t("Order.RelationFields.created_time"),
        align: "start",
        sortable: false,
        value: "created",
      },
      {
        text: i18n.t("TableHeaders.actions"),
        align: "start",
        sortable: false,
        value: "actions",
      },
    ],

    isSubDisabled() {
      //开启分账，不能修改商品数量
      return !!(
        this.settings.sub_account_enable &&
        (this.settings.sub_account_modify_enable != 1 ||
          (this.settings.sub_account_modify_enable == 1 &&
            this.subAccountEditStatus &&
            this.subAccountEditStatus.shop_bill != 4 &&
            this.subAccountEditStatus.shop_bill != 19 &&
            this.order &&
            this.order.bill &&
            (this.order.bill.pay_flg == 2 || this.order.bill.pay_flg == 3) &&
            this.subAccountEditStatus.sub_account_status.edit_num == 0 &&
            !this.settings.abnormal_examine))
      );
    },

    isEditNumEnable() {
      // 开启分账且订单商品数据可以修改，对账单类型不为要货下单且是只可增加且是部分支付或已支付要货单做限制
      return !!(
        this.settings &&
        this.settings.sub_account_enable &&
        this.settings.sub_account_modify_enable == 1 &&
        this.subAccountEditStatus &&
        this.subAccountEditStatus.shop_bill != 4 &&
        this.subAccountEditStatus.shop_bill != 19 &&
        this.order &&
        this.order.bill &&
        (this.order.bill.pay_flg == 2 || this.order.bill.pay_flg == 3) &&
        !this.settings.abnormal_examine &&
        this.subAccountEditStatus.sub_account_status.edit_num == 1
      );
    },

    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["loading", "settings", "accountUser", "subAccountEditStatus"]),
  },

  data: () => ({
    panels: [0],
    tab: null,
    filter: "",
    mode: "",
    examine: {},
    receiverInfo: {},
    examineDetails: [],
    examine_img: [],
    examine_activities: [],
    examine_relations: [],
    imgRules: [
      (value) =>
        !value || value.size < 10000000 || i18n.t("AccountAds.imgHint"),
    ],
    album: [],
    imgs_file: [],
    order: {},
    img_file_one: null,
    img_file_two: null,
    img_file_three: null,
    img_one: "",
    img_two: "",
    img_three: "",
    img_url_one: "",
    img_url_two: "",
    img_url_three: "",
    showImgTwoFlg: false,
    showImgThreeFlg: false,
    editExamineImg: false,
  }),

  mounted() {
    if (this.$route.params.mode) {
      this.mode = this.$route.params.mode;
    } else {
      this.mode = "view";
    }
  },

  methods: {
    getExamineDetailFromAPI() {
      Examines.fetchOne(this.$route.params.id, { order_activity: 1 }).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.examine = response.data.examine;
            this.receiverInfo = response.data.order_address;
            this.examineDetails = response.data.examine.examine_details;
            this.examine_activities = response.data.order_activities;
            this.album = [];
            if (response.data.examine.examine_file_url.image_url) {
              response.data.examine.examine_file_url.image_url.forEach(
                (img) => {
                  this.album.push(img);
                }
              );
            }
            if (response.data.examine.examine_file_url.video_url) {
              response.data.examine.examine_file_url.video_url.forEach(
                (video) => {
                  this.album.push(video);
                }
              );
            }
            this.resetExamineImg();

            this.examineDetails.forEach((detail) => {
              if (this.savable && !detail.examine_num) {
                detail.examine_num = detail.distribution_num;
              }
            });
            this.getOrderFromAPI(this.examine.order_id);
          }
        }.bind(this)
      );

      Examines.fetchRelations(this.$route.params.id).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.examine_relations = [];
            this.examine_relations.push(
              Object.assign(
                {
                  controller: "Orders",
                  identify: "orders",
                  identify_name: i18n.t("Order.ObjectName"),
                  identify_code: response.data.order.order_code,
                },
                response.data.order
              )
            );
            this.examine_relations.push(
              Object.assign(
                {
                  controller: "StockOuts",
                  identify: "stock-orders-out",
                  identify_name: i18n.t("StockOrderOUT.ObjectName"),
                  identify_code: response.data.stock_order.stock_order_code,
                },
                response.data.stock_order
              )
            );
            this.examine_relations.push(
              Object.assign(
                {
                  controller: "Distributions",
                  identify: "distributions",
                  identify_name: i18n.t("Distribution.ObjectName"),
                  identify_code: response.data.distribution.distributions_code,
                },
                response.data.distribution
              )
            );
            this.examine_relations.push(
              Object.assign(
                {
                  controller: "Examines",
                  identify: "examines",
                  identify_name: i18n.t("Examine.ObjectName"),
                  identify_code: response.data.examine.examine_code,
                  status: response.data.examine.is_examined,
                },
                response.data.examine
              )
            );
            this.examine_relations.push(
              Object.assign(
                {
                  controller: "Receipt",
                  identify: "receipts",
                  identify_name: i18n.t("Bill.ObjectName"),
                  identify_code: response.data.bill.bill_code,
                },
                response.data.bill
              )
            );
          }
        }.bind(this)
      );
    },

    async doSubmit() {
      this.$store.dispatch("fullscreenLoading");
      // 检查一下图片上传的error，拒绝上传
      if (this.$refs.img_file_one.hasError) {
        this.$store.dispatch("fullscreenLoadingStop");
        return;
      }
      if (this.$refs.img_file_two && this.$refs.img_file_two.hasError) {
        this.$store.dispatch("fullscreenLoadingStop");
        return;
      }
      if (this.$refs.img_file_three && this.$refs.img_file_three.hasError) {
        this.$store.dispatch("fullscreenLoadingStop");
        return;
      }

      //提交图片集
      let examine_img = [];
      let imgs_file = [];
      if (this.img_file_one) {
        imgs_file.push(this.img_file_one);
      } else if (this.img_one) {
        examine_img.push(
          this.img_one.substring(this.img_one.lastIndexOf("/") + 1)
        );
      }

      if (this.img_file_two) {
        imgs_file.push(this.img_file_two);
      } else if (this.img_two) {
        examine_img.push(
          this.img_two.substring(this.img_two.lastIndexOf("/") + 1)
        );
      }

      if (this.img_file_three) {
        imgs_file.push(this.img_file_three);
      } else if (this.img_three) {
        examine_img.push(
          this.img_three.substring(this.img_three.lastIndexOf("/") + 1)
        );
      }

      if (imgs_file && imgs_file.length > 0) {
        let response = await Files.filesUpload(imgs_file, "images");
        if (response.data.status.isOK()) {
          response.data.data.forEach((file) =>
            examine_img.push(file.file_name)
          );
        }
      }

      let examine_details = [];
      this.examineDetails.forEach((detail) => {
        examine_details.push({
          material_id: detail.material.id,
          examine_num: detail.examine_num,
          auto_flg: detail.auto_flg,
          unit: detail.unit,
        });
      });
      this.$refs.observer.validate().then(
        function (result) {
          if (result) {
            Examines.examine({
              id: this.examine.id,
              examine_img: examine_img,
              examine_details: examine_details,
            })
              .then(
                function (response) {
                  if (response.data.status.isOK()) {
                    this.$router.push("/examines");
                    this.$store.dispatch("fullscreenLoadingStop");
                  } else {
                    this.$store.dispatch("fullscreenLoadingStop");
                  }
                }.bind(this)
              )
              .catch(
                function () {
                  this.$store.dispatch("fullscreenLoadingStop");
                }.bind(this)
              );
          } else {
            this.$store.dispatch("fullscreenLoadingStop");
          }
        }.bind(this)
      );
    },
    getOrderFromAPI(order_id) {
      Orders.fetchOne(order_id).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.order = response.data.order;
          }
        }.bind(this)
      );
    },
    async updateExamineImg() {
      this.$store.dispatch("fullscreenLoading");
      // 检查一下图片上传的error，拒绝上传
      if (this.$refs.img_file_one.hasError) {
        this.$store.dispatch("fullscreenLoadingStop");
        return;
      }
      if (this.$refs.img_file_two && this.$refs.img_file_two.hasError) {
        this.$store.dispatch("fullscreenLoadingStop");
        return;
      }
      if (this.$refs.img_file_three && this.$refs.img_file_three.hasError) {
        this.$store.dispatch("fullscreenLoadingStop");
        return;
      }

      //提交图片集
      let examine_img = [];
      var imgs_file = [];
      if (this.img_file_one) {
        imgs_file.push(this.img_file_one);
      } else if (this.img_one) {
        examine_img.push(
          this.img_one.substring(this.img_one.lastIndexOf("/") + 1)
        );
      }

      if (this.img_file_two) {
        imgs_file.push(this.img_file_two);
      } else if (this.img_two) {
        examine_img.push(
          this.img_two.substring(this.img_two.lastIndexOf("/") + 1)
        );
      }

      if (this.img_file_three) {
        imgs_file.push(this.img_file_three);
      } else if (this.img_three) {
        examine_img.push(
          this.img_three.substring(this.img_three.lastIndexOf("/") + 1)
        );
      }

      if (imgs_file && imgs_file.length > 0) {
        let response = await Files.filesUpload(imgs_file, "images");
        if (response.data.status.isOK()) {
          response.data.data.forEach((file) =>
            examine_img.push(file.file_name)
          );
        }
      }

      Examines.examineImgUpdate({
        examine_code: this.examine.examine_code,
        examine_img:
          examine_img && examine_img.length > 0 ? examine_img.join(";") : "",
      })
        .then(
          function (response) {
            if (response.data.status.isOK()) {
              this.$snackbar.success(
                i18n.t("Examine.Messages.updateExamineImgSuccess")
              );
              this.getExamineDetailFromAPI();
              this.$store.dispatch("fullscreenLoadingStop");
            } else {
              this.$store.dispatch("fullscreenLoadingStop");
            }
          }.bind(this)
        )
        .catch(
          function () {
            this.$store.dispatch("fullscreenLoadingStop");
          }.bind(this)
        );
    },
    resetExamineImg() {
      this.img_file_one = null;
      this.img_file_two = null;
      this.img_file_three = null;
      this.showImgTwoFlg = false;
      this.showImgThreeFlg = false;
      this.img_url_one = this.img_one =
        this.album && this.album[0] ? this.album[0] : "";
      this.img_url_two = this.img_two =
        this.album && this.album[1] ? this.album[1] : "";
      this.img_url_three = this.img_three =
        this.album && this.album[2] ? this.album[2] : "";
      if (this.album && this.album[1]) {
        this.showImgTwoFlg = true;
      }
      if (this.album && this.album[2]) {
        this.showImgThreeFlg = true;
      }
    },
  },

  watch: {
    mode: {
      handler() {
        if (this.$route.params.id) this.getExamineDetailFromAPI();
      },
    },
    examineDetails: {
      deep: true,
      handler() {
        this.examine.total_subtotal_price = 0;
        this.examine.total_examine_num = 0;
        let total_subtotal_price = 0;
        let total_examine_num = 0;
        this.examineDetails.forEach((detail) => {
          if (
            detail.examine_num != detail.distribution_num &&
            this.examine.abnormal_flg
          ) {
            detail.abnormal_flg = 1;
          }
          if (this.isView && !this.examine.is_examined) {
            detail.subtotal_price = this.$numberFormatter.formatMoneyFloor(
              parseFloat((detail.price * detail.distribution_num).toFixed(4))
            ); //小计
          } else {
            detail.subtotal_price = this.$numberFormatter.formatMoneyFloor(
              parseFloat((detail.price * detail.examine_num).toFixed(4))
            ); //小计
          }

          total_subtotal_price += Number(detail.subtotal_price);
          total_examine_num += Number(detail.examine_num);
        });
        this.examine.total_subtotal_price += total_subtotal_price;
        this.examine.total_examine_num += total_examine_num;
      },
    },
    img_one: {
      handler() {
        if (!this.img_one) {
          this.img_file_one = null;
        }
      },
    },

    img_file_one: {
      handler() {
        if (this.img_file_one) {
          var reader = new FileReader();
          reader.readAsDataURL(this.img_file_one);
          let that = this;
          reader.onload = function () {
            that.img_one = this.result;
          };
        } else {
          this.img_one = this.img_url_one;
        }
      },
    },
    img_two: {
      handler() {
        if (!this.img_two) {
          this.img_file_two = null;
        }
      },
    },

    img_file_two: {
      handler() {
        if (this.img_file_two) {
          var reader = new FileReader();
          reader.readAsDataURL(this.img_file_two);
          let that = this;
          reader.onload = function () {
            that.img_two = this.result;
          };
        } else {
          this.img_two = this.img_url_two;
        }
      },
    },
    img_three: {
      handler() {
        if (!this.img_three) {
          this.img_file_three = null;
        }
      },
    },

    img_file_three: {
      handler() {
        if (this.img_file_three) {
          var reader = new FileReader();
          reader.readAsDataURL(this.img_file_three);
          let that = this;
          reader.onload = function () {
            that.img_three = this.result;
          };
        } else {
          this.img_three = this.img_url_three;
        }
      },
    },
  },
};
</script>